import classNames from 'classnames/bind';
import type { ComponentPropsWithoutRef } from 'react';

import styleIdentifiers from './BarChartTooltip.module.scss';

const styles = classNames.bind(styleIdentifiers);

type BarChartTooltipProps = ComponentPropsWithoutRef<'div'> & {
  multi?: boolean;
};

export const BarChartTooltip = ({ multi, className, ...props }: BarChartTooltipProps) => (
  <div className={styles('bar-chart-tooltip', { multi }, className)} {...props} />
);
